import { useEffect } from 'react'

export function useGasEstimateResets(
  isLocked: boolean,
  ...resets: (() => void)[]
) {
  useEffect(() => {
    if (!isLocked) {
      resets.forEach(reset => reset())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLocked, ...resets])
}
